export const SN_STOCK = 'stock'
export const STOCK_ADD_PRODUCT = SN_STOCK + '/ADD_PRODUCT'
export const STOCK_ADD_PRODUCTS = SN_STOCK + '/ADD_PRODUCTS'